module.exports = __webpack_public_path__ + "static/media/titar_logo_black.33fa0bab.png";